import axios from 'axios';
import api from './api';

export function getExceptions() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/exceptions`);
}

export function saveException(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/requests`, data)
}

export function omitException(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/cancel/credits/${data.idCredito}`, data);
}

export function getExceptionsByAsesor(idAsesor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/adviser/${idAsesor}/credits`);
}

export function getExceptionsById(idCredito, idExcepcionSolicitud) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/credits/${idCredito}/exception-request/${idExcepcionSolicitud}`)
}

export function updateException(data) {
  return api({
    method: 'post',
    url: '${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/exceptions',
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function backToDataSolicitation(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${data.idCredito}/state/EN_REGISTRO_DATOS_ADICIONALES_CLIENTE`, data)
}

export function postExceptions(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/finalize/credits/${data.idCredito}`, data)
}

export function skipException(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/skip/credits/${data.idCredito}`, data)
}

export function verifyException(idCredito) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/exception-stage/offices/credits/${idCredito}`);  
}
